import { Injectable } from '@angular/core';
import { IQuotationXrates } from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";
import { Observable, of } from "rxjs";
import { RuntimeError } from "libraries/service/error-tracing/runtime-error.model";
import { Yii } from "libraries/interfaces/Yii";
import { EXRateType } from "libraries/interfaces/ITotal";

export interface ICurrencyRateLegacy {
    id: number;
    currencyCode: string;
    countryCode?: string;
    targetCurrencyCode: string;
    rate: number;
    isCostPrice: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  public searchCurrenciesRates(currencyXRates: IQuotationXrates[], sourceCurrency: string, targetCurrency: string): Observable<ICurrencyRateLegacy[]> {
    if (!currencyXRates || !sourceCurrency || !targetCurrency) {
      return of();
    }

    const resultRates: ICurrencyRateLegacy[] = currencyXRates
        .filter((xRate: IQuotationXrates): boolean => xRate.source === sourceCurrency && xRate.target === targetCurrency)
        .map((xRate: IQuotationXrates): ICurrencyRateLegacy => ({
          id: xRate.id,
          currencyCode: xRate.source,
          targetCurrencyCode: xRate.target,
          rate: Number.parseFloat(xRate.rate),
          isCostPrice: xRate.type === EXRateType.cost,
        }));

    if (resultRates.length === 0) {
        throw new RuntimeError(Yii.t('wui-shared-js', 'Aucun taux de change correspondant.'));
    }

    return of(resultRates);
  }
}
